import { DatePicker, Form, Input, Row, Col } from "antd";
import React, { useEffect, useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import moment from "moment";

const PaymentLCFields = ({
  handleSubmit,
  formKey,
  state,
  handleDatepickerChange,
  handlePaymentChange,
  updateLCFieldsValidity,
}) => {
  const { t } = useTranslation();
  const formRef = useRef(null);

  useEffect(() => {
    validateFields();
    formRef.current.setFieldsValue({
      lc_open_date:
        state.company_payment_terms[0].lc_open_date === null
          ? null
          : moment(state.company_payment_terms[0].lc_open_date, "DD-MM-YY"),
      lc_validity_complation_date:
        state.company_payment_terms[0].lc_validity_complation_date === null
          ? null
          : moment(
              state.company_payment_terms[0].lc_validity_complation_date,
              "DD-MM-YY"
            ),
      lc_value:
        state.company_payment_terms[0].lc_value === null
          ? null
          : state.company_payment_terms[0].lc_value,
      lc_supply_limit_value:
        state.company_payment_terms[0].lc_supply_limit_value === null
          ? null
          : state.company_payment_terms[0].lc_supply_limit_value,
    });
  }, [state]);

  const validateFields = () => {
    const isBankFieldsFilled =
      state.company_payment_terms[0].lc_value &&
      state.company_payment_terms[0].lc_supply_limit_value &&
      state.company_payment_terms[0].lc_open_date &&
      state.company_payment_terms[0].lc_validity_complation_date;
    updateLCFieldsValidity(isBankFieldsFilled);
  };

  return (
    <div>
      {" "}
      <>
        <Form
          onFinish={handleSubmit}
          autoComplete="off"
          key={formKey}
          ref={formRef}
        >
          {" "}
          <Row gutter={[15]}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                label={t("pl_lc_value")}
                name="lc_value"
                key={formKey}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_lc_value")}</Trans>,
                  },
                ]}
              >
                <Input
                  type="number"
                  addonBefore="₹"
                  placeholder={t("pl_lc_value")}
                  onKeyPress={(e) => {
                    if (e.key === "." || e.key === "e") {
                      e.preventDefault(); 
                    }
                  }}
                  onChange={(e) =>
                    handlePaymentChange(
                      "lc_value",
                      parseInt(e.target.value, 10) || null
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                label={t("pl_lc_supply_limit_value")}
                name="lc_supply_limit_value"
                key={formKey}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_lc_supply_limit_value")}</Trans>,
                  },
                ]}
              >
                <Input
                  type="number"
                  addonBefore="₹"
                  placeholder={t("pl_lc_supply_limit_value")}
                  onKeyPress={(e) => {
                    if (e.key === "." || e.key === "e") {
                      e.preventDefault(); 
                    }
                  }}
                  onChange={(e) =>
                    handlePaymentChange(
                      "lc_supply_limit_value",
                      parseInt(e.target.value, 10) || null
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="lc_open_date"
                label={t("pl_lc_open_date")}
                key={formKey}
              >
                <DatePicker
                  inputReadOnly
                  format={"DD-MM-YY"}
                  onChange={(date, dateString) =>
                    handleDatepickerChange(date, dateString, "lc_open_date")
                  }
                  value={
                    state.company_payment_terms[0].lc_open_date
                      ? state.company_payment_terms[0].lc_open_date
                      : null
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="lc_validity_complation_date"
                label={t("pl_lc_validity_complation_date")}
                key={formKey}
              >
                <DatePicker
                  inputReadOnly
                  format={"DD-MM-YY"}
                  onChange={(date, dateString) =>
                    handleDatepickerChange(
                      date,
                      dateString,
                      "lc_validity_complation_date"
                    )
                  }
                  value={
                    state.company_payment_terms[0].lc_validity_complation_date
                      ? state.company_payment_terms[0]
                          .lc_validity_complation_date
                      : null
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </>
    </div>
  );
};
PaymentLCFields.propTypes = {
  handleSubmit: PropTypes.func,
  formKey: PropTypes.number,
  state: PropTypes.func,
  handleDatepickerChange: PropTypes.func,
  handlePaymentChange: PropTypes.func,
  updateLCFieldsValidity: PropTypes.func,
};
export default PaymentLCFields;
